import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { appTheme } from '../../../theme';
import { FormBox, PageLink } from '../../common';
import EmailRegisterForm from './EmailRegisterForm';

const RegistrationPage = styled.div`
  align-items: center;
  display: flex;
  height: calc(100vh - ${appTheme.sizing.headerHeight});
  justify-content: center;
`;

const RegistrationBoxTitle = styled.h1`
  color: ${appTheme.system.title};
  margin: 0;
  text-align: center;
`;

function RegistrationFormPage({ fetchTerms, onRegister }) {
  return (
    <RegistrationPage>
      <FormBox>
        <RegistrationBoxTitle>Sign Up</RegistrationBoxTitle>
        <EmailRegisterForm fetchTerms={fetchTerms} onRegister={onRegister} />
        <PageLink to="/login">
          Already have an account? Click here to login.
        </PageLink>
      </FormBox>
    </RegistrationPage>
  );
}

RegistrationFormPage.propTypes = {
  fetchTerms: PropTypes.func.isRequired,
  onRegister: PropTypes.func.isRequired,
};

export default RegistrationFormPage;



// WEBPACK FOOTER //
// ./src/modules/RegistrationFormPage/components/RegistrationFormPage.js